import React from "react";
import { HostProfileEdit } from "../HostProfileEdit";

export const HostProfile: React.FC = () => {
  return <HostProfileEdit viewonly={true} canDelete={true} />;
};
